/*
 * This visitor removes a field from the measures object if the fieldToCheck is not present in the measures object.
 * It is used to clean up IRR and TVPI quartile rankings if they don't have values, because
 * quartile rankings are calculated on PACE while IRR and TVPI are reported values or calculated values
 * (if they are calculated, then they are calculated differently than quartile rankings,
 * quartile rankings are using transactions, while IRR and TVPI are using fund holdings),
 * and we are not supposed to show quartile rankings if they are not having values.
 * @param fieldToRemove - The field to remove from the measures object.
 * @param fieldToCheck - The field to check for presence in the measures object.
 * @returns A NodesVisitor function that removes the field from the measures object if the fieldToCheck is not present.
 */
export const removeIfMissingVisitor = (fieldToRemove, fieldToCheck) => (args) => {
    if (!fieldToRemove || fieldToRemove === "" || !fieldToCheck || fieldToCheck === "") {
        return;
    }
    const measureToCheck = args.visitable.measures?.[fieldToCheck];
    if (measureToCheck) {
        return;
    }
    if (args.visitable.measures) {
        delete args.visitable.measures[fieldToRemove];
    }
};
